import React from "react"
import { MappedCourse } from "../../lib/prismic/MappedCourse"
import { Alert } from "antd"

export const CourseCloseAlert = ({ style, course }: { style?: React.CSSProperties; course?: MappedCourse }) => (
  <Alert
    style={style}
    type="info"
    showIcon
    description={
      course?.id
        ? `Registrace na kurz "${course.name}" jsou uzavřeny. ${
            course?.firstCourseDay ? `Kurz se konal od ${course.firstCourseDay.format("l")} (${course.firstCourseDay.fromNow()}).` : ""
          }`
        : `Registrace na tento kurz je již uzavřena. Přihlaste se k odběru novinek na svůj e-mail prostřednictvím tlačítka „Odběr novinek“ a my vás budeme informovat o nově otevřených kurzech. Děkujeme za váš zájem.`
    }
    message={`Registrace jsou uzavřeny`}
  />
)
